<template>
  <div class="bg-white">
    <div class="p-10 px-6 md:p-20 xl:w-4/5">
      <!--<p class="text-xl md:text-2xl font-serif">{{ $t('home.about-us.together-to-grow') }}</p>-->
      <p class="text-sm md:text-base mt-5">{{ $t('home.about-us.care-since-2019') }}</p>
      <p class="text-sm md:text-base mt-5">{{ $t('home.about-us.our-goal') }}</p>
      <p class="text-sm md:text-base mt-5">{{ $t('home.about-us.join-us') }}</p>
      <NuxtLink :to="localePath('/about-us')">
        <Button class="bg-tau-red mt-8 w-full md:w-auto">
          <div>{{ $t('home.about-us.learn-more') }}</div>
        </Button>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
</script>

<style></style>